(() => {
  const ROOT_SEL = "[data-pickup-root]";
  const LIST_SEL = "[data-pickup-list]";
  const TPL_ID = "PickupArticleTpl";
  const PICKUP_TAG = "pickup";
  const LIMIT = 3;

  const root = document.querySelector(ROOT_SEL);
  if (!root) return;

  const list = root.querySelector(LIST_SEL);
  const tpl = document.getElementById(TPL_ID);
  if (!list || !tpl) return;
  const fallbackImage = root.dataset.fallbackImage || "";

  const toMs = (isoLike) => {
    const ms = Date.parse(isoLike);
    return Number.isFinite(ms) ? ms : 0;
  };

  const render = (items) => {
    list.innerHTML = "";

    const picks = items
      .filter((x) => Array.isArray(x.tags) && x.tags.map(String).includes(PICKUP_TAG))
      .sort((a, b) => toMs(b.published_at) - toMs(a.published_at))
      .slice(0, LIMIT);

    if (!picks.length) {
      root.style.display = "none";
      return;
    }

    picks.forEach((a) => {
      const node = tpl.content.cloneNode(true);
      const link = node.querySelector(".blog-pickup__link");
      const img = node.querySelector(".blog-pickup__img");
      const heading = node.querySelector(".blog-pickup__heading");
      const date = node.querySelector(".blog-pickup__date");

      if (link) link.href = a.url;
      if (heading) heading.textContent = a.title || "";

      if (date && a.published_date) {
        date.textContent = a.published_date;
      }

      if (img) {
        const src = a.image || fallbackImage;
        if (src) {
          img.src = src;
          img.alt = a.title || "";
        } else {
          img.remove();
        }
      }

      list.appendChild(node);
    });
  };

  const fetchJsonView = async (q) => {
    // /search のパスを優先（言語プレフィックスがあるストアでも安定しやすい）
    const base = (window.routes && window.routes.search_url) ? window.routes.search_url : "/search";

    const url = new URL(base, window.location.origin);
    url.searchParams.set("q", q);
    url.searchParams.set("type", "article");
    url.searchParams.set("view", "pickup-json");
    // 検索ヒット数が多い場合に備えて多めに取る（あとで3件に絞る）
    url.searchParams.set("options[prefix]", "last");

    const res = await fetch(url.toString(), { headers: { "Accept": "application/json" } });
    if (!res.ok) throw new Error(`search fetch failed: ${res.status}`);
    return res.json();
  };

  (async () => {
    try {
      // 1) tag:pickup を試す（効く環境なら最速）
      const data1 = await fetchJsonView(`tag:${PICKUP_TAG}`);
      if (data1?.items?.length) {
        render(data1.items);
        return;
      }

      // 2) pickup の素検索 → tagsでpickupだけ抽出（効かない環境への保険）
      const data2 = await fetchJsonView(PICKUP_TAG);
      render(data2?.items || []);
    } catch (e) {
      // 失敗したら非表示
      console.warn(e);
      root.style.display = "none";
    }
  })();
})();
